// Título/description por ruta. Sin react-helmet: es un solo <head> (no hay SSR), así que
// alcanza con actualizar document.title y la meta description a mano en cada cambio de
// ruta — ver App.js. Fallback al final para rutas no listadas.
const DEFAULT_META = {
  title: 'QUINLATE Shop — Joyería laminada en oro 18k y gorras',
  description:
    'Joyería laminada en oro 18k y gorras QUINLATE. Piezas hechas para durar — compra directo o por WhatsApp, envíos a todo México.',
};

const PAGE_META = {
  '/': DEFAULT_META,
  '/gorras': {
    title: 'Gorras QUINLATE',
    description: 'Gorras QUINLATE, ediciones premium. Compra directo o por WhatsApp, envíos a todo México.',
  },
  '/joyeria': {
    title: 'Joyería QUINLATE — Laminado en oro 18k',
    description: 'Cadenas, esclavas y rosarios QUINLATE laminados en oro 18k. Compra directo o por WhatsApp.',
  },
  '/lentes': {
    title: 'Lentes QUINLATE — Edición Cartier',
    description: 'Lentes QUINLATE Edición Cartier. Compra directo o por WhatsApp.',
  },
  '/van-cleef': {
    title: 'Van Cleef QUINLATE — Laminado en oro 18k',
    description: 'Esclava Van Cleef QUINLATE laminada en oro 18k, 4 colores. Compra directo o por WhatsApp.',
  },
  '/conjuntos': {
    title: 'Joyería Conjuntos QUINLATE — Laminado en oro 18k',
    description: 'Conjuntos de collar y esclava QUINLATE laminados en oro 18k, precio de paquete. Compra directo o por WhatsApp.',
  },
  '/emprendedor': {
    title: 'Emprende con nosotros — QUINLATE',
    description: 'Paquetes por mayoreo QUINLATE para revender. Compra directo o por WhatsApp.',
  },
  '/carrito': {
    title: 'Tu carrito — QUINLATE',
    description: 'Revisa tu pedido QUINLATE y paga con Mercado Pago o coordina por WhatsApp.',
  },
  // Título neutro: ConfirmationPage lo cambia según el estado verificado del pago (antes
  // decía "Gracias por tu compra" aunque el pago hubiera fallado).
  '/gracias': {
    title: 'Tu pedido — QUINLATE',
    description: 'Confirmación de compra y datos de envío — QUINLATE Shop.',
  },
  '/privacidad': {
    title: 'Aviso de privacidad — QUINLATE',
    description: 'Aviso de privacidad de QUINLATE Shop.',
  },
};

export function getPageMeta(pathname) {
  return PAGE_META[pathname] || DEFAULT_META;
}
